<template>
  <div>
    <div class="oner">
      <div class="left">分类</div>
      <div class="right">
        <div class="bottom" :class="blue == 1?'bottom blue':'bottom'" @click="changStyale(1)">线上</div>
        <div class="bottom" :class="blue == 2?'bottom blue':'bottom'" @click="changStyale(2)">线下</div>
      </div>
    </div>
    <AssessmentScoreOnLine v-if="blue == 1"></AssessmentScoreOnLine>
    <AssessmentScoreOffLine v-if="blue == 2"></AssessmentScoreOffLine>
  </div>
</template>

<script>
import AssessmentScoreOnLine from "./AssessmentScoreOnLine.vue"
import AssessmentScoreOffLine from "./AssessmentScoreOffLine.vue"

export default {
  name: "AssessmentScore",
  components: { AssessmentScoreOnLine, AssessmentScoreOffLine },
  data () {
    return {
      blue: 1,
    };
  },
  mounted () {

  },
  methods: {
    changStyale (val) {
      this.blue = val;
    }
  }
};
</script>

<style scoped lang="scss">
.oner {
  width: 1060px;
  height: 84px;
  background: #f7f8fa;
  display: flex;
  .left {
    margin: 30px 10px 20px 40px;
    font-size: 18px;
    color: #999;
  }
  .right {
    display: flex;
    padding: 20px;
    width: 400px;
    .bottom {
      margin: 0 30px;
      width: 80px;
      height: 41px;
      padding: 10px 22px;
      font-size: 18px;
      color: #333;
      cursor: pointer;
    }
  }
  .blue {
    border-radius: 4px;
    color: #fff !important;
    background: #2b59f0;
    border-radius: 4px;
  }
}

.Fail {
  color: #f45d5d;
}
.adopt {
  color: #69d235;
}
</style>
